import axios from 'axios';
import router from '../routes'
import { deleteToken, deleteEmail, getToken, getEmail } from '../utils/authority'
// 全局设置相关

const requestErrorHandle = {
  401: function() {
    deleteToken();
    deleteEmail();
    router.replace('/');
  }
}
// axios全局设置
// 请求拦截
axios.interceptors.request.use(function (config) {
  config.headers['X-YMJ-Token'] = getToken();
  config.headers['X-YMJ-Email'] = getEmail();
  return config;
}, function (error) {
  return Promise.reject(error);
});


// 请求相应全局设置
axios.interceptors.response.use(response => {
  return response
}, error => {
  const { status } = error.response;
 
  requestErrorHandle[status] && requestErrorHandle[status]();
  return Promise.resolve(error.response)
});





// WEBPACK FOOTER //
// ./src/global/index.js